export default __webpack_public_path__ + "static/media/toggle_icon.73e47a14.png";